/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSignalOff: {
  name: 'signal-off';
  data: string;
} = {
  name: 'signal-off',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.707 3.293a1 1 0 0 0-1.414 1.414l16 16a1 1 0 0 0 1.414-1.414l-16-16ZM21 15V4a1 1 0 1 0-2 0v11a1 1 0 1 0 2 0Zm-5-8a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V7Zm-1 11a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1Zm-4-4a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Zm-6-2a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
